import { application } from "./application";

import { registerControllers } from "stimulus-vite-helpers";

// App-specific controllers
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)

// Shared controllers from shipped-base
import TomSelectController from "shipped-base/app/javascript/controllers/tom_select_controller"
import DialcodeController from "shipped-base/app/javascript/controllers/dialcode_controller"
import CountrySelectController from "shipped-base/app/javascript/controllers/country_select_controller"
application.register("tom-select", TomSelectController)
application.register("dialcode", DialcodeController)
application.register("country-select", CountrySelectController)
